/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, perWeek: NonNullable<unknown>, planned: NonNullable<unknown> }} Progress_Report_Consistency_MonthInputs */

const en_us2_progress_report_consistency_month = /** @type {(inputs: Progress_Report_Consistency_MonthInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 workout · ${i?.perWeek} a week, of ${i?.planned} planned`);
	return /** @type {LocalizedString} */ (`${i?.done} workouts · ${i?.perWeek} a week, of ${i?.planned} planned`)
	
};

const pt_br2_progress_report_consistency_month = /** @type {(inputs: Progress_Report_Consistency_MonthInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 treino · ${i?.perWeek} por semana, de ${i?.planned} planejados`);
	return /** @type {LocalizedString} */ (`${i?.done} treinos · ${i?.perWeek} por semana, de ${i?.planned} planejados`)
	
};

const es_419_progress_report_consistency_month = /** @type {(inputs: Progress_Report_Consistency_MonthInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 entrenamiento · ${i?.perWeek} por semana, de ${i?.planned} planeados`);
	return /** @type {LocalizedString} */ (`${i?.done} entrenamientos · ${i?.perWeek} por semana, de ${i?.planned} planeados`)
	
};

const pt_pt2_progress_report_consistency_month = /** @type {(inputs: Progress_Report_Consistency_MonthInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 treino · ${i?.perWeek} por semana, de ${i?.planned} planeados`);
	return /** @type {LocalizedString} */ (`${i?.done} treinos · ${i?.perWeek} por semana, de ${i?.planned} planeados`)
	
};

const fr_fr2_progress_report_consistency_month = /** @type {(inputs: Progress_Report_Consistency_MonthInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 séance · ${i?.perWeek} par semaine, sur ${i?.planned} prévues`);
	return /** @type {LocalizedString} */ (`${i?.done} séances · ${i?.perWeek} par semaine, sur ${i?.planned} prévues`)
	
};

const de_de2_progress_report_consistency_month = /** @type {(inputs: Progress_Report_Consistency_MonthInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 Training · ${i?.perWeek} pro Woche, von ${i?.planned} geplanten`);
	return /** @type {LocalizedString} */ (`${i?.done} Trainings · ${i?.perWeek} pro Woche, von ${i?.planned} geplanten`)
	
};

const it_it2_progress_report_consistency_month = /** @type {(inputs: Progress_Report_Consistency_MonthInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 allenamento · ${i?.perWeek} a settimana, su ${i?.planned} previsti`);
	return /** @type {LocalizedString} */ (`${i?.done} allenamenti · ${i?.perWeek} a settimana, su ${i?.planned} previsti`)
	
};

/**
* | done | output |
* | --- | --- |
* | "1" | "1 workout · {perWeek} a week, of {planned} planned" |
* | * | "{done} workouts · {perWeek} a week, of {planned} planned" |
*
* @param {Progress_Report_Consistency_MonthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_consistency_month = /** @type {((inputs: Progress_Report_Consistency_MonthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Consistency_MonthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_consistency_month(inputs)
	if (locale === "es-419") return es_419_progress_report_consistency_month(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_consistency_month(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_consistency_month(inputs)
	if (locale === "de-DE") return de_de2_progress_report_consistency_month(inputs)
	if (locale === "it-IT") return it_it2_progress_report_consistency_month(inputs)
	return en_us2_progress_report_consistency_month(inputs)
});
export { progress_report_consistency_month as "progress-report.consistency_month" }